import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { Period } from "../../generated/core-api";

export function useGroupActiveUsers(
  groupId: string,
  fromDate: string,
  toDate: string,
  period: Period,
  enabled = true,
) {
  return useQuery({
    queryKey: ["groupAnalytics", groupId, "activeUsers", fromDate, toDate, period],
    queryFn: () =>
      api.getGroupActiveUsers(groupId, {
        from_date: fromDate,
        to_date: toDate,
        period,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
